import { Dialog } from '@root/shared/ui-kit'

import {
  CurrencySelectorContent,
  type CurrencySelectorContentProps,
} from './CurrencySelectorContent'

import type { ClassNameProps } from '@root/shared/react'
import type { DialogProps } from '@root/shared/ui-kit'

export type CurrencySelectorDrawerProps = {
  title: string
} & CurrencySelectorContentProps &
  Pick<DialogProps, 'onOpenChange' | 'open'> &
  ClassNameProps

export const CurrencySelectorModal: React.FC<CurrencySelectorDrawerProps> = (
  props,
) => (
  <Dialog
    open={props.open}
    onOpenChange={props.onOpenChange}
    describedBy={props.title}
    className={props.className}
  >
    <Dialog.Header title={props.title} />
    <CurrencySelectorContent {...props} />
  </Dialog>
)
